import api from "./api";

function normalize(value) {
  return String(value || "").trim().toLowerCase();
}

function emptyGovernance() {
  return {
    layers: [],
    roleContext: {
      roleNames: [],
      visibleLayerKeys: [],
    },
    vocabulary: {
      canonical: "bestuurlijke_structuur",
      uiLabels: ["Beheerstructuur"],
    },
    notes: [],
  };
}

export async function fetchGovernanceStructure() {
  const res = await api.get("/governance/structure");
  const payload = res?.data?.governance;
  if (!payload || typeof payload !== "object") {
    return emptyGovernance();
  }
  return {
    ...emptyGovernance(),
    ...payload,
    layers: Array.isArray(payload.layers) ? payload.layers : [],
    roleContext: payload.roleContext && typeof payload.roleContext === "object"
      ? payload.roleContext
      : { roleNames: [], visibleLayerKeys: [] },
  };
}

export function findGovernanceLayer(governance, key) {
  const layers = Array.isArray(governance?.layers) ? governance.layers : [];
  const target = normalize(key);
  return layers.find((layer) => normalize(layer?.key) === target) || null;
}
